export type AppNames =
  | 'ADMIN'
  | 'CHAT'
  | 'COMPASS'
  | 'CONNECT'
  | 'CONSULTING'
  | 'CREATORS'
  | 'HEIMDALL'
  | 'LIBRARY'
  | 'PREDICT'
  | 'PXM'
  | 'SHELF'
  | 'TOGGLE'

export const APP_LOGOS: {
  [key in AppNames]: {
    logo: string
    abbr: string
    isolated: string
  }
} = {
  ADMIN: {
    logo: 'https://images.pattern.com/pattern_exp_logos/admin.svg',
    abbr: 'https://images.pattern.com/pattern_exp_logos/admin-abbr.svg',
    isolated: 'https://images.pattern.com/pattern_exp_logos/admin-isolated.svg',
  },
  CHAT: {
    logo: 'https://images.pattern.com/pattern_exp_logos/chat.svg',
    abbr: 'https://images.pattern.com/pattern_exp_logos/chat-abbr.svg',
    isolated: 'https://images.pattern.com/pattern_exp_logos/chat-isolated.svg',
  },
  COMPASS: {
    logo: 'https://images.pattern.com/pattern_exp_logos/compass.svg',
    abbr: 'https://images.pattern.com/pattern_exp_logos/compass-abbr.svg',
    isolated:
      'https://images.pattern.com/pattern_exp_logos/compass-isolated.svg',
  },
  CONNECT: {
    logo: 'https://images.pattern.com/pattern_exp_logos/connect.svg',
    abbr: 'https://images.pattern.com/pattern_exp_logos/connect-abbr.svg',
    isolated:
      'https://images.pattern.com/pattern_exp_logos/connect-isolated.svg',
  },
  CONSULTING: {
    logo: 'https://images.pattern.com/pattern_exp_logos/consulting.svg',
    abbr: 'https://images.pattern.com/pattern_exp_logos/consulting-abbr.svg',
    isolated:
      'https://images.pattern.com/pattern_exp_logos/consulting-isolated.svg',
  },
  CREATORS: {
    logo: 'https://images.pattern.com/pattern_exp_logos/creators.svg',
    abbr: 'https://images.pattern.com/pattern_exp_logos/creators-abbr.svg',
    isolated:
      'https://images.pattern.com/pattern_exp_logos/creators-isolated.svg',
  },
  HEIMDALL: {
    logo: 'https://images.pattern.com/pattern_exp_logos/heimdall.svg',
    abbr: 'https://images.pattern.com/pattern_exp_logos/heimdall-abbr.svg',
    isolated:
      'https://images.pattern.com/pattern_exp_logos/heimdall-isolated.svg',
  },
  LIBRARY: {
    logo: 'https://images.pattern.com/pattern_exp_logos/library.svg',
    abbr: 'https://images.pattern.com/pattern_exp_logos/library-abbr.svg',
    isolated:
      'https://images.pattern.com/pattern_exp_logos/library-isolated.svg',
  },
  PREDICT: {
    logo: 'https://images.pattern.com/pattern_exp_logos/predict.svg',
    abbr: 'https://images.pattern.com/pattern_exp_logos/predict-abbr.svg',
    isolated:
      'https://images.pattern.com/pattern_exp_logos/predict-isolated.svg',
  },
  PXM: {
    logo: 'https://images.pattern.com/pattern_exp_logos/pxm.svg',
    abbr: 'https://images.pattern.com/pattern_exp_logos/pxm-abbr.svg',
    isolated: 'https://images.pattern.com/pattern_exp_logos/pxm-abbr.svg',
  },
  SHELF: {
    logo: 'https://images.pattern.com/pattern_exp_logos/shelf.svg',
    abbr: 'https://images.pattern.com/pattern_exp_logos/shelf-abbr.svg',
    isolated: 'https://images.pattern.com/pattern_exp_logos/shelf-isolated.svg',
  },
  TOGGLE: {
    logo: 'https://images.pattern.com/pattern_exp_logos/toggle.svg',
    abbr: 'https://images.pattern.com/pattern_exp_logos/toggle-abbr.svg',
    isolated:
      'https://images.pattern.com/pattern_exp_logos/toggle-isolated.svg',
  },
}
